/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { jobActions } from '../../../../_actions';


function countTimeStampReduce(array) {
    if (!Array.isArray(array)) {
        return 0;
    }

    return array.reduce((acc, x) => acc + (x.offSiteTime - x.onSiteTime), 0);
}


function countTimeStampReduceData(array) {
    if (!Array.isArray(array)) {
        return 0;
    }

    return array.reduce((acc, x) => acc + (x.endTime - x.startTime), 0);
}
function convertMilliseconds(milliseconds) {
    const hours = Math.floor(milliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
    const remainingMilliseconds = milliseconds % 1000;

    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: remainingMilliseconds
    };
}


const EditInvoice = ({ jobMaterialDetails, viewRowData, propsData, setEditInvoice, handelCreateApi, callMaterialAPI }) => {

    const newData1 = useMemo(() => {
        if (!jobMaterialDetails?.MaterialUsed) return [];

        return jobMaterialDetails.MaterialUsed.flatMap(ele =>
            ele?.materials?.map(e => ({
                ...e,
                labour: ele?.userId?.id,
                id: e._id // Ensure consistent ID usage
            })) || []
        );
    }, [jobMaterialDetails]);

    const newData2= useMemo(() => {
        if (!jobMaterialDetails?.MaterialUsed) return [];

        return jobMaterialDetails.MaterialUsed.flatMap(ele =>
            ele?.equipment?.map(e => ({
                ...e,
                labour: ele?.userId?.id,
                id: e._id // Ensure consistent ID usage
            })) || []
        );
    }, [jobMaterialDetails]);
    const newData3 = useMemo(() => viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData?.assigned_internal_staff_status_m?.reduce((acc, x) => acc + countTimeStampReduce(x.timeData), 0) : viewRowData?.assigned_worker_status?.reduce((acc, x) => acc + countTimeStampReduce(x.timeData), 0), [viewRowData])


    const newData4 = useMemo(() => viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData?.assigned_internal_staff_status_m?.reduce((acc, x) => acc + countTimeStampReduceData(x.travelLogs), 0) : viewRowData?.assigned_worker_status?.reduce((acc, x) => acc + countTimeStampReduceData(x.travelLogs), 0), [viewRowData])

    const [formData, setFormData] = useState(() => ({
        company_name: viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData.created_by.company_name : viewRowData?.assign_to?.company_name,
        job_address: `${viewRowData?.location_id?.linecomplete}, ${viewRowData?.location_id?.pin}, ${viewRowData?.location_id?.city}, ${viewRowData?.location_id?.state}`,
        taxNumber: `${jobMaterialDetails?.invoiceDetailsByJobId?.taxRegistrationNo || ""}`,
        job_title: viewRowData?.job_title,
        invoice_number: viewRowData?.job_id?.replace(/^(DM|PM) - /, ""),
        invoice_date: moment().format("YYYY-MM-DD"),
        ats_job_id: viewRowData?.job_id,
        bill_to: `${viewRowData?.created_by?.first_name} ${viewRowData?.created_by?.last_name}`,
        address: viewRowData?.created_by?.address,
        phone: viewRowData?.created_by?.contact,
        materialDetails: newData1,
        equipmentDetails: newData2,
        totals: {
            subtotal: 0,
            salesTax: jobMaterialDetails?.invoiceDetailsByJobId?.salesTax ?? 0,
            total: 0,
            taxRate: jobMaterialDetails?.invoiceDetailsByJobId?.taxRate ?? 0,
            deposit: jobMaterialDetails?.invoiceDetailsByJobId?.depositReceived ?? 0
        },
        job_details: viewRowData?.job_details,
        jobQtyHours: convertMilliseconds(newData3).hours,
        jobQtyMinutes: convertMilliseconds(newData3).minutes,
        jobQtySeconds: convertMilliseconds(newData3).seconds,
        jobRate: `${jobMaterialDetails?.invoiceDetailsByJobId?.jobRate || 0}`,
        jobPrice: jobMaterialDetails?.invoiceDetailsByJobId?.jobPrice || 0,
        travelQtyHours: convertMilliseconds(newData4).hours,
        travelQtyMinutes: convertMilliseconds(newData4).minutes,
        travelQtySeconds: convertMilliseconds(newData4).seconds,
        travelRate: `${jobMaterialDetails?.invoiceDetailsByJobId?.travelRate || 0}`,
        travelPrice: jobMaterialDetails?.invoiceDetailsByJobId?.travelPrice || 0,
        jobPriceType: jobMaterialDetails?.invoiceDetailsByJobId?.jobPriceType || "Hourly",
        travelPriceType: jobMaterialDetails?.invoiceDetailsByJobId?.travelPriceType || "Hourly"

    }));

    const totalTimeReturnData = () => {
        const hours = formData.jobQtyHours;
        const minutes = formData.jobQtyMinutes;
        const seconds = formData.jobQtySeconds;
        const totalHours = hours + minutes / 60 + seconds / 3600;
        return totalHours
    }


    const totalTimeReturnDataTravel = () => {
        const hours = formData.travelQtyHours;
        const minutes = formData.travelQtyMinutes;
        const seconds = formData.travelQtySeconds;
        const totalHours = hours + minutes / 60 + seconds / 3600;
        return totalHours
    }

    const formatCurrency = (value) => {
        if (value === null || value === undefined || isNaN(value)) {
            return Number(0).toFixed(2);
        }
        return Number(value).toFixed(2);
    };
    const calculateTotals = useMemo(() => {
        const jobTotal = formData.jobPriceType === "Flat" ? formData.jobPrice : (totalTimeReturnData() * parseFloat(formData.jobRate || 0));
        const travelTotal = formData.travelPriceType === "Flat" ? formData.travelPrice : (totalTimeReturnDataTravel() * parseFloat(formData.travelRate || 0));
        const subtotal = parseFloat(jobTotal) + parseFloat(travelTotal) +
            formData.materialDetails.reduce((sum, item) => sum + parseFloat(item?.price || 0), 0) +
            formData.equipmentDetails.reduce((sum, item) => sum + parseFloat(item?.price || 0), 0);

        const salesTax = (subtotal * (formData.totals.taxRate || 0)) / 100;
        const total = subtotal + salesTax - (formData.totals.deposit || 0);
        return {
            subtotal: Number(formatCurrency(subtotal)),
            salesTax: Number(formatCurrency(salesTax)),
            total: Number(formatCurrency(total)),
            deposit: Number(formatCurrency(formData.totals.deposit)),
            taxRate: Number(formatCurrency(formData.totals.taxRate))
        };
    }, [formData]);

    useEffect(() => {
        setFormData(prevState => ({
            ...prevState,
            totals: calculateTotals
        }));
    }, [
        formData.jobRate,
        formData.jobPriceType,  // Job price type dependency
        formData.travelRate,
        formData.jobPrice,
        formData.travelPrice,
        formData.travelPriceType,  // Travel price type dependency
        JSON.stringify(formData?.materialDetails),
        JSON.stringify(formData?.equipmentDetails),
        formData.totals.taxRate,
        formData.totals.deposit
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        setErrors(prevState => ({
            ...prevState,
            [name]: ""
        }))
    };

    const handleTotalsChange = (e) => {
        const { name, value } = e.target;
        if (!isNaN(value)) {
            setFormData(prevState => ({
                ...prevState,
                totals: {
                    ...prevState.totals,
                    [name]: parseFloat(value) || 0
                }
            }));
        }
    };


    const handleMaterialChange = (index, e) => {
        const { name, value } = e.target;
        const updatedMaterials = [...formData.materialDetails];

        if (name === 'qty' || name === 'rate') {
            updatedMaterials[index] = {
                ...updatedMaterials[index],
                [name]: parseFloat(value) || 0,
                price: (name === 'qty' ? (parseFloat(value) || 0) * (updatedMaterials[index].rate || 0) :
                    (parseFloat(value) || 0) * (updatedMaterials[index].qty || 1))
            };
        } else {
            updatedMaterials[index] = { ...updatedMaterials[index], [name]: value };
        }

        setFormData(prevState => ({
            ...prevState,
            materialDetails: updatedMaterials
        }));
    };


    const handleEquipmentChange = (index, e) => {
        const { name, value } = e.target;
        const updatedEquipment = [...formData.equipmentDetails];

        if (name === 'qty' || name === 'rate') {
            updatedEquipment[index] = {
                ...updatedEquipment[index],
                [name]: parseFloat(value) || 0,
                price: (name === 'qty' ? (parseFloat(value) || 0) * (updatedEquipment[index].rate || 0) :
                    (parseFloat(value) || 0) * (updatedEquipment[index].qty || 1))
            };
        } else {
            updatedEquipment[index] = { ...updatedEquipment[index], [name]: value };
        }

        setFormData(prevState => ({
            ...prevState,
            equipmentDetails: updatedEquipment
        }));
    };

    const handleJobDetailsChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleTravelDetailsChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: parseFloat(value) || 0
        }));
    };


    const handleSubmit = (e) => {

        e.preventDefault();
        if (validateAndSetErrors()) {


            if (allLabour.length > 0) {
                for (let i = 0; i < allLabour.length; i++) {
                    const data = allLabour[i];
                    const details = {
                        jobId: viewRowData.id,
                        userId: data.value,
                        materials: formData.materialDetails
                            .filter((ele) => ele.labour === data.value)
                            ?.map((ele) => {
                                const { labour, id,_id, ...res } = ele;
                                return {
                                    ...res
                                };
                            }),
                        equipment: formData.equipmentDetails
                            .filter((ele) => ele.labour === data.value)
                            ?.map((ele) => {
                                const { labour, id,_id, ...res } = ele;
                                return {
                                    ...res
                                };
                            })
                    };
                    const existData = jobMaterialDetails.MaterialUsed.find(ele => ele?.userId?.id === data.value)
                    if (existData){
                        propsData.dispatch(jobActions.updateMaterialDetailsByJobId({ ...details, id: existData._id}))
                    }else if (details.equipment.length > 0 || details.materials.length > 0) {
                        propsData.dispatch(jobActions.createMaterialUsedAdmin(details));
                    }
                }
            }

            const detailsInvoice = {
                "jobId": viewRowData.id,
                "invoiceSubtotal": formData.totals.subtotal,
                "taxRate": formData.totals.taxRate,
                "salesTax": formData.totals.salesTax,
                "depositReceived": formData.totals.deposit,
                "invoiceNum": formData.invoice_number,
                "invoiceDate": formData.invoice_date,
                "taxRegistrationNo": formData.taxNumber,
                jobRate: !isNaN(formData?.jobRate) ? Number(formData?.jobRate) : 0,
                jobPrice: formData.jobPriceType === "Flat" ? formData.jobPrice : totalTimeReturnData() * formData.jobRate,
                travelRate: formData.travelRate,
                travelPrice: formData.travelPriceType === "Flat" ? formData.travelPrice : totalTimeReturnDataTravel() * formData.travelRate,
                jobPriceType: formData.jobPriceType,
                travelPriceType: formData.travelPriceType,
            }
            handelCreateApi(detailsInvoice)
            callMaterialAPI({ "jobId": viewRowData.id})
            setEditInvoice(false)
        }
    };

    const [errors, setErrors] = useState({})

    // const validateAndSetErrors = () => {
    //     const error = {}
    //     if (!formData.taxNumber) {
    //         error["taxNumber"] = "Tax Registration Number cannot be empty"
    //     }

    //     setErrors(error)

    //     return Object.keys(error).length === 0
    // }

    const validateAndSetErrors = () => {
        const error = {}
        if (!formData.taxNumber) {
            error["taxNumber"] = "Tax Registration Number cannot be empty"
        }
        // eslint-disable-next-line eqeqeq
        if (!formData.jobPrice && formData.jobPriceType == "Flat") {
            error["jobPrice"] = "Job Rate cannot be empty"
        }
        // if (!formData.travelPrice &&  formData.travelPriceType=="Flat") {
        //     error["travelPrice"] = "Job Rate cannot be empty"
        // }

        setErrors(error)

        return Object.keys(error).length === 0
    }


    const formatTime = (hours, minutes, seconds) => {
        return `${hours}h ${minutes}m ${seconds}s`;
    };

    const [newMaterial, setNewMaterial] = useState({
        description: '',
        qty: 1,
        labour: '',
        rate: 0,
        price: 0
    });
    const [newEquipment, setNewEquipment] = useState({
        description: '',
        qty: 1,
        rate: 0,
        labour: '',
        price: 0
    });


    const allLabour = useMemo(() => {
        const internalStaff = viewRowData?.assigned_internal_staff_status_m?.map((acc) => ({
            label: `${acc?.staffId?.first_name} ${acc?.staffId?.last_name}`,
            value: `${acc?.staffId?.id}`
        })) || [];

        const workers = viewRowData?.assigned_worker_status?.map((worker) => ({
            label: `${worker?.workerId?.first_name} ${worker?.workerId?.last_name}` || 'Unknown Worker', // You can modify this as per worker details
            value: `${worker?.workerId?.id}`,  // Assuming workerId is available
        })) || [];

        // Merge both internal staff and workers
        return [...internalStaff, ...workers];
    }, [viewRowData]);

    const addMaterial = () => {
        if (newMaterial.description.trim() === '') {
            setErrors(prev => ({ ...prev, newMaterial: "Description is required" }));
            return;
        }
        if (newMaterial.labour.trim() === '') {
            setErrors(prev => ({ ...prev, materialLabour: "Labour is required" }));
            return;
        }

        setFormData(prev => ({
            ...prev,
            materialDetails: [
                ...prev.materialDetails,
                {
                    id: Date.now().toString(),
                    materialDescription: newMaterial.description,
                    labour: newMaterial.labour,
                    qty: parseFloat(newMaterial.qty) || 1,
                    rate: parseFloat(newMaterial.rate) || 0,
                    price: (parseFloat(newMaterial.qty) || 1) * (parseFloat(newMaterial.rate) || 0)
                }
            ]
        }));

        setNewMaterial({
            description: '',
            qty: 1,
            labour: "",
            rate: 0,
            price: 0
        });
        setErrors(prev => ({ ...prev, newMaterial: '' }));
    };


   

    const handleNewMaterialChange = (e) => {
        const { name, value } = e.target;
        setNewMaterial(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'qty' || name === 'rate') {
                updated.price = (parseFloat(updated.qty) || 0) * (parseFloat(updated.rate) || 0);
            }
            return updated;
        });
    };

    const handleNewEquipmentChange = (e) => {
        const { name, value } = e.target;
        setNewEquipment(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'qty' || name === 'rate') {
                updated.price = (parseFloat(updated.qty) || 0) * (parseFloat(updated.rate) || 0);
            }
            return updated;
        });
    };

    const addEquipment = () => {
        if (newEquipment.description.trim() === '') {
            setErrors(prev => ({ ...prev, newEquipment: "Description is required" }));
            return;
        }

        if (newEquipment.labour.trim() === '') {
            setErrors(prev => ({ ...prev, equipmentLabour: "Labour is required" }));
            return;
        }
        setFormData(prev => ({
            ...prev,
            equipmentDetails: [
                ...prev.equipmentDetails,
                {
                    id: Date.now().toString(),
                    equipmentDescription: newEquipment.description,
                    labour: newEquipment.labour,
                    qty: parseFloat(newEquipment.qty) || 1,
                    rate: parseFloat(newEquipment.rate) || 0,
                    price: (parseFloat(newEquipment.qty) || 1) * (parseFloat(newEquipment.rate) || 0)
                }
            ]
        }));

        setNewEquipment({
            description: '',
            qty: 1,
            labour: '',
            rate: 0,
            price: 0
        });
        setErrors(prev => ({ ...prev, newEquipment: '' }));
    };

    const removeMaterial = (id) => {
        setFormData(prev => ({
            ...prev,
            materialDetails: prev.materialDetails.filter(item => item.id !== id)
        }));
    };

    const removeEquipment = (id) => {
        setFormData(prev => ({
            ...prev,
            equipmentDetails: prev.equipmentDetails.filter(item => item.id !== id)
        }));
    };


    return (
        <div style={{ padding: "0 20px", width: '80%', border: "5px solid #2e74b5", margin: "45px auto" }}>
            <form onSubmit={handleSubmit}>
                <div style={{ margin: 'auto' }}>
                    <div style={{ display: "flex", justifyContent: "space-between", margin: '20px 0' }}>
                        <img
                            src="./Logo V2.jpg"
                            alt="logo"
                            width={80}
                        />
                        <h1 style={{ paddingRight: "70px" }}>INVOICE</h1>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', textTransform: "capitalize" }}>
                        <div style={{ width: '45%' }}>
                            <p><strong>Company Name: </strong>
                                {formData.company_name}
                            </p>
                            <p><strong>Job Address: </strong>
                                {formData.job_address}
                            </p>
                            <p>Tax Registration No.:
                                <input
                                    type="text"
                                    name="taxNumber"
                                    value={formData?.taxNumber}
                                    onChange={handleChange}
                                />
                                {
                                    errors && errors["taxNumber"] && <p style={{ color: "red" }}>{errors["taxNumber"]}</p>
                                }
                            </p>
                            <p><strong>Job Title:</strong>
                                {formData?.job_title || "N/A"}
                            </p>
                        </div>
                        <div style={{ width: '50%' }}>
                            <p><strong>Invoice : </strong>#<input type="text" name="invoice_number" value={formData.invoice_number} onChange={handleChange} /></p>
                            <p><strong>Invoice date:</strong> <input type="date" name="invoice_date" value={formData.invoice_date} onChange={handleChange} /></p>
                            <p><strong>ATS Job ID No.: </strong> {formData.ats_job_id}</p>
                            <p><strong>Bill to: </strong>
                                {formData.company_name}
                            </p>
                            <p><strong>Address: </strong>
                                {formData.address}
                            </p>
                            <p><strong>Phone: </strong>
                                {formData.phone}
                            </p>
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Location</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Time (hours)</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Price Type</th>
                                    {formData.travelPriceType !== "Flat" && <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Rate</th>}
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {/* {viewRowData?.created_by?.address} */}
                                        {formData.job_address}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {formatTime(formData.travelQtyHours, formData.travelQtyMinutes, formData.travelQtySeconds)}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <select
                                            name="travelPriceType"
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    travelPriceType: e.target.value,
                                                    travelPrice: e.target.value === "Flat"
                                                        ? prev.travelPrice
                                                        : totalTimeReturnDataTravel() * prev.travelRate
                                                }));
                                            }}
                                            value={formData?.travelPriceType}
                                        >
                                            <option value={"Hourly"}>Hourly Rate</option>
                                            <option value={"Flat"}>Flat Rate</option>
                                        </select>
                                    </td>
                                    {formData.travelPriceType !== "Flat" && <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="travelRate"
                                            disabled={formData.travelPriceType === "Flat"}
                                            value={formData.travelRate}
                                            onChange={handleTravelDetailsChange}
                                        />
                                        {
                                            errors && errors["travelRate"] && <p style={{ color: "red" }}>{errors["travelRate"]}</p>
                                        }
                                    </td>}
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {formData?.travelPriceType === "Flat" ? <input
                                            type="number"
                                            name="travelPrice"
                                            value={formData.travelPrice}
                                            onChange={handleTravelDetailsChange}
                                        /> : ((totalTimeReturnDataTravel() * formData.travelRate) > 0 ? (totalTimeReturnDataTravel() * formData.travelRate).toFixed(2): 0)}
                                        {
                                            errors && errors["travelPrice"] && <p style={{ color: "red" }}>{errors["travelPrice"]}</p>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Job Details</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty (hours)</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Job Price Type</th>
                                    {formData.jobPriceType !== "Flat" && <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Rate</th>}
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{formData.job_details}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {formatTime(formData.jobQtyHours, formData.jobQtyMinutes, formData.jobQtySeconds)}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <select
                                            name="jobPriceType"
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    jobPriceType: e.target.value,
                                                    jobPrice: e.target.value === "Flat"
                                                        ? prev.jobPrice
                                                        : totalTimeReturnData() * prev.jobRate
                                                }));
                                            }}
                                            value={formData?.jobPriceType}
                                        >
                                            <option value={"Hourly"}>Hourly Rate</option>
                                            <option value={"Flat"}>Flat Rate</option>
                                        </select>
                                    </td>
                                    {formData.jobPriceType !== "Flat" && <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="jobRate"
                                            value={formData.jobRate}
                                            disabled={formData.jobPriceType === "Flat"}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d*$/.test(value)) {
                                                    handleJobDetailsChange(e);
                                                }
                                            }}
                                        />
                                        {errors && errors["jobRate"] && <p style={{ color: "red" }}>{errors["jobRate"]}</p>}
                                    </td>}

                                    <td style={{ border: '1px solid #000', padding: '8px' }}>

                                        {formData?.jobPriceType === "Flat" ? (
                                            <input
                                                type="number"
                                                name="jobPrice"
                                                value={formData.jobPrice}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleJobDetailsChange(e);
                                                    }
                                                }}
                                            />
                                        ) : (
                                            (totalTimeReturnData() * formData.jobRate).toFixed(2)
                                        )}
                                        {errors && errors["jobPrice"] && <p style={{ color: "red" }}>{errors["jobPrice"]}</p>}
                                        {/* {(totalTimeReturnData() * formData.jobRate).toFixed(2)} */}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Materials Description </th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Labour</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Per Item</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData?.materialDetails?.map((material, index) => (
                                    <tr key={material.id}>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="text"
                                                name="materialDescription"
                                                value={material?.materialDescription}
                                                onChange={(e) => handleMaterialChange(index, e)}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <select
                                                name="labour"
                                                value={material?.labour}
                                                onChange={(e) => handleMaterialChange(index, e)}
                                                style={{ width: '100%' }}
                                            >
                                                <option value={""}>Select Labour</option>
                                                {allLabour?.map((ele) => {
                                                    return <option value={ele?.value}>{ele?.label}</option>
                                                })}
                                            </select>
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="number"
                                                name="qty"
                                                value={material?.qty}
                                                onChange={(e) => handleMaterialChange(index, e)}
                                                min="1"
                                                style={{ width: '60px' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="number"
                                                name="rate"
                                                value={material?.rate}
                                                onChange={(e) => handleMaterialChange(index, e)}
                                                step="0.01"
                                                style={{ width: '80px' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            {material.price.toFixed(2)}
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => removeMaterial(material.id)}
                                                style={{ background: 'red', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px' }}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {errors.materialDetails && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.materialDetails}</p>}
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="text"
                                            name="description"
                                            value={newMaterial.description}
                                            onChange={handleNewMaterialChange}
                                            placeholder="New material description"
                                            style={{ width: '100%' }}
                                        />
                                        {errors.newMaterial && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.newMaterial}</p>}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <select
                                            name="labour"
                                            value={newMaterial?.labour}
                                            onChange={handleNewMaterialChange}
                                            style={{ width: '100%' }}
                                        >
                                            <option value={""}>Select Labour</option>
                                            {allLabour?.map((ele) => {
                                                return <option value={ele?.value}>{ele?.label}</option>
                                            })}
                                        </select>
                                        {errors?.materialLabour && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.materialLabour}</p>}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="qty"
                                            value={newMaterial.qty}
                                            onChange={handleNewMaterialChange}
                                            min="1"
                                            style={{ width: '60px' }}
                                        />
                                    </td>

                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="rate"
                                            value={newMaterial.rate}
                                            onChange={handleNewMaterialChange}
                                            step="0.01"
                                            style={{ width: '80px' }}
                                        />
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {newMaterial.price.toFixed(2)}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                                        <button
                                            type="button"
                                            onClick={addMaterial}
                                            style={{ background: 'green', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px' }}
                                        >
                                            Add
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Equipment Description</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Labour</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Per Item</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                                    <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.equipmentDetails.map((equipment, index) => (
                                    <tr key={index}>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="text"
                                                name="equipmentDescription"
                                                value={equipment.equipmentDescription}
                                                onChange={(e) => handleEquipmentChange(index, e)}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <select
                                                name="labour"
                                                value={equipment?.labour}
                                                onChange={(e) => handleMaterialChange(index, e)}
                                                style={{ width: '100%' }}
                                            >
                                                <option value={""}>Select Labour</option>
                                                {allLabour?.map((ele) => {
                                                    return <option value={ele?.value}>{ele?.label}</option>
                                                })}
                                            </select>
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="number"
                                                name="qty"
                                                value={equipment.qty}
                                                onChange={(e) => handleEquipmentChange(index, e)}
                                                min="1"
                                                style={{ width: '60px' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            <input
                                                type="number"
                                                name="rate"
                                                value={equipment.rate}
                                                onChange={(e) => handleEquipmentChange(index, e)}
                                                step="0.01"
                                                style={{ width: '80px' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            {equipment.price.toFixed(2)}
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => removeEquipment(equipment.id)}
                                                style={{ background: 'red', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px' }}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {errors.equipmentDetails && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.equipmentDetails}</p>}
                                <tr>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="text"
                                            name="description"
                                            value={newEquipment.description}
                                            onChange={handleNewEquipmentChange}
                                            placeholder="New equipment description"
                                            style={{ width: '100%' }}
                                        />
                                        {errors.newEquipment && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.newEquipment}</p>}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <select
                                            name="labour"
                                            value={newEquipment?.labour}
                                            onChange={handleNewEquipmentChange}
                                            style={{ width: '100%' }}
                                        >
                                            <option value={""}>Select Labour</option>
                                            {allLabour?.map((ele) => {
                                                return <option value={ele?.value}>{ele?.label}</option>
                                            })}
                                        </select>
                                        {errors.equipmentLabour && <p style={{ color: "red", margin: '5px 0 0', fontSize: '12px' }}>{errors.equipmentLabour}</p>}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="qty"
                                            value={newEquipment.qty}
                                            onChange={handleNewEquipmentChange}
                                            min="1"
                                            style={{ width: '60px' }}
                                        />
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        <input
                                            type="number"
                                            name="rate"
                                            value={newEquipment.rate}
                                            onChange={handleNewEquipmentChange}
                                            step="0.01"
                                            style={{ width: '80px' }}
                                        />
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>
                                        {newEquipment.price.toFixed(2)}
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                                        <button
                                            type="button"
                                            onClick={addEquipment}
                                            style={{ background: 'green', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px' }}
                                        >
                                            Add
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ marginBottom: '20px', display: 'flex', justifyContent: "flex-end" }}>
                        <table style={{ width: '50%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                            <tbody>
                                <tr>
                                    <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Invoice Subtotal:</th>
                                    <td style={{ padding: '8px', border: '1px solid #000' }}>
                                        {formData.totals.subtotal}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Tax Rate %:</th>
                                    <td style={{ padding: '8px', border: '1px solid #000' }}>
                                        <input
                                            type="number"
                                            name="taxRate"
                                            value={formData.totals.taxRate}
                                            onChange={handleTotalsChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Sales Tax:</th>
                                    <td style={{ padding: '8px', border: '1px solid #000' }}>
                                        {formData.totals.salesTax}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Deposit Received:</th>
                                    <td style={{ padding: '8px', border: '1px solid #000' }}>
                                        <input
                                            type="number"
                                            name="deposit"
                                            value={formData.totals.deposit}
                                            onChange={handleTotalsChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Total:</th>
                                    <td style={{ padding: '8px', border: '1px solid #000' }}>
                                        {formData.totals.total}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', marginBottom: "10px" }}>
                        <button type="submit" style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: '#2e74b5', color: 'white', border: 'none', borderRadius: '4px' }}>Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EditInvoice;
